import { useState } from "react";
import { Plus } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/dropdown-menu";
import { useAnnouncementModal } from "./announcement/use-announcement-modal";

export const CreationForAdmin = () => {
  const { onOpenChange: onAnnouncementOpen } = useAnnouncementModal();
  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger className="transition-all duration-300 hover:bg-ring/10 p-2 rounded-full">
        <Plus className="w-5 h-5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="p-3 mr-5">
        <DropdownMenuItem
          onMouseDown={() => {
            onAnnouncementOpen(true);
            setOpen(false);
          }}
        >
          Make an announcement
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
